import { defineMessages } from 'react-intl';

type MessageKeys = 'today' | 'yesterday' | 'thisWeek' | 'thisMonth' | 'furtherBack' | 'now';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		today: {
			id: 'ai-mate.rovo-navigation.side-navigation.time.today',
			defaultMessage: 'Today',
			description: 'Relative time label, today',
		},
		yesterday: {
			id: 'ai-mate.rovo-navigation.side-navigation.time.yesterday',
			defaultMessage: 'Yesterday',
			description: 'Relative time label, yesterday',
		},
		thisWeek: {
			id: 'ai-mate.rovo-navigation.side-navigation.time.this-week',
			defaultMessage: 'This past week',
			description: 'Relative time label, the past 7 days',
		},
		thisMonth: {
			id: 'ai-mate.rovo-navigation.side-navigation.time.this-month',
			defaultMessage: 'This past month',
			description: 'Relative time label, the past 30 days',
		},
		furtherBack: {
			id: 'ai-mate.rovo-navigation.side-navigation.time.further-back',
			defaultMessage: 'Further back',
			description: 'Relative time label, greater than 30 days ago',
		},
		now: {
			id: 'ai-mate.rovo-navigation.side-navigation.time.now',
			defaultMessage: 'Just now',
			description: 'Relative time label, less than 1 minute',
		},
	});

export default message;
